<!-- 编排对阵 -->
<template>
   <div class="">
    <div class="flex-row-center mg-b-10">       
        <div>
            <span class="title">第{{round}}轮 编排</span>        
        </div>    
        <div class="flex-row edit-item" v-if="isShowEdit"> 
            <span class="tips">请点击要调整的选手编号</span>
            <el-input v-model="playerNo1" @input="handleInput1" maxlength="3"
                placeholder="选手编号" class="player-input"></el-input>
            <el-input v-model="playerNo2" @input="handleInput2" maxlength="3"
                placeholder="选手编号" class="player-input"></el-input>     
            <el-button type="danger" @click="savePlayer" class="save-btn">确认调整</el-button>  
        </div>
        <div class="edit-btn my-button-container">
            <el-button type="success" @click="backNext"  v-if="isShowEdit">返回</el-button>
            <el-button type="success" @click="editTable" v-else>人工调整</el-button>            
        </div>        
    </div>  
    <div class="mg-b-10 my-button-container">
        <el-button type="primary" @click="handleArrangeAll" class="mg-l-10" v-if="round !==1"
        :disabled="disabled" >编排</el-button>
        <el-button type="success" @click="handleArrangeRandom" v-if="round ===1 && roundOne"
        class="mg-l-10 ">随机编排</el-button>
        <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
        <el-button type="primary" @click="handleClearArrange" class="mg-l-10" >清除编排</el-button>
        <span class="red size18">{{ errorMsg }}</span>
    </div>
    <!-- 人工调整 -->
    <div v-if="isShow" >
        <div class="flex-row-1 custom-table2">
            <el-table class="custom-table"
                v-if="tableDataSetFirst.length > 0"
                @cell-click="changeSeat"
                :data="tableDataSetFirst"
                :row-class-name="tableRowClassName"
                style="width: 60%" border>
            <el-table-column
                prop="id"
                label="编号"
                align="center"
                width="100">
            </el-table-column>
            <el-table-column
                prop="username"
                align="center"
                label="选手"            
                >
            </el-table-column>
            <el-table-column
                prop="seat"
                align="center"
                width="100"
                label="方位">
            </el-table-column>
            <el-table-column
                prop="deskNo"
                align="center"
                label="桌号"
                width="100">
            </el-table-column>
        </el-table>   
        <el-table class="custom-table"
            v-if="tableDataSetSecond.length > 0"
            @cell-click="changeSeat"
            :data="tableDataSetSecond"
            :row-class-name="tableRowClassName"
            style="width: 60%;margin-left: 15px;" border>
            <el-table-column
                prop="id"
                label="编号"
                align="center"
                width="100">
            </el-table-column>
            <el-table-column
                prop="username"
                align="center"
                label="选手"            
                >
            </el-table-column>
            <el-table-column
                prop="seat"
                align="center"
                width="100"
                label="方位">
            </el-table-column>
            <el-table-column
                prop="deskNo"
                align="center"
                label="桌号"
                width="100">
            </el-table-column>
        </el-table>   
        </div>        
    </div>
    <!-- 编排显示的表格 -->
    <div v-if="isReady">
        <div class="flex-row-1 custom-table2" v-if="pubType === '1'">
            <el-table class="custom-table"    
                v-loading.fullscreen="loading"
                element-loading-text="正在编排中，请稍后..."           
                v-if="firstTableData.length > 0"
                :data="firstTableData"
                :row-class-name="tableRowClassName"
                style="width: 60%" border>
            <el-table-column
                prop="deskNo"
                label="桌号"
                width="120"
                align="center"  
                >
            </el-table-column>
            <el-table-column
                prop="usernameW"
                label="东"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>
                </div>
            </template>
            </el-table-column>    
            <el-table-column
                prop="usernameE"
                label="西"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusE === '弃权'? 'gray-row':''"> {{ scope.row.usernameE }}</span>
                </div>
            </template>
            </el-table-column>   
            <el-table-column
                prop="usernameS"
                label="南"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>
                </div>
            </template>
            </el-table-column>      
            <el-table-column
                prop="usernameN"
                label="北"
                align="center"  
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN}}</span>
                </div>
            </template>
            </el-table-column>  
            <el-table-column  fixed="right" label="操作"  width="80">
                <template slot-scope="scope">
                    <el-button @click="handleNewArrange(scope.row)" v-if="scope.row.status === '未编排'"
                    type="text" style="font-size:16px;color:red">确认加桌</el-button>
                </template>
            </el-table-column>
            </el-table>
            <el-table class="custom-table" 
                v-if="secondTableData.length > 0"
                :data="secondTableData"
                :row-class-name="tableRowClassName"
                style="width: 60%;margin-left: 15px;" border>
            <el-table-column
                prop="deskNo"
                label="桌号"
                width="120"
                align="center"  
                >
            </el-table-column>
            <el-table-column
                prop="usernameW"
                label="东"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>
                </div>
            </template>
            </el-table-column>    
            <el-table-column
                prop="usernameE"
                label="西"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusE === '弃权'? 'gray-row':''"> {{ scope.row.usernameE }}</span>
                </div>
            </template>
            </el-table-column>   
            <el-table-column
                prop="usernameS"
                label="南"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>
                </div>
            </template>
            </el-table-column>      
            <el-table-column
                prop="usernameN"
                label="北"
                align="center"  
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN }}</span>
                </div>
            </template>
            </el-table-column>  
            <el-table-column  fixed="right" label="操作"  width="80">
                <template slot-scope="scope">
                    <el-button @click="handleNewArrange(scope.row)" v-if="scope.row.status === '未编排'"
                    type="text" style="font-size:16px;color:red">确认加桌</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="flex-row-1 custom-table2" v-else>
            <el-table class="custom-table" 
                v-loading.fullscreen="loading"
                element-loading-text="正在编排中，请稍后..."  
                v-if="firstTableData.length > 0"
                :data="firstTableData"
                :row-class-name="tableRowClassName"
                style="width: 60%" border>
               
                <el-table-column
                    prop="usernameWE"
                    label="东西"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column> 
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="70"
                    align="center"  
                    >
                </el-table-column>      
                <el-table-column
                    prop="usernameSN"
                    label="南北"
                    align="center"  
                >
                <template slot-scope="scope">
                    <div>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN}}</span>
                    </div>
                </template>
                </el-table-column>  
                <el-table-column  fixed="right" label="操作"  width="80">
                    <template slot-scope="scope">
                        <el-button @click="handleNewArrange(scope.row)" v-if="scope.row.status === '未编排'"
                        type="text" style="font-size:16px;color:red">确认加桌</el-button>
                    </template>
                </el-table-column>
            </el-table> 
            <el-table class="custom-table" 
                v-if="secondTableData.length > 0"
                :data="secondTableData"
                :row-class-name="tableRowClassName"
                style="width: 60%;margin-left: 15px;" border>                
                <el-table-column
                    prop="usernameWE"
                    label="东西"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                    </div>
                </template>
                </el-table-column>  
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="70"
                    align="center"  
                    >
                </el-table-column>     
                <el-table-column
                    prop="usernameSN"
                    label="南北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN }}</span>
                    </div>
                </template>
                </el-table-column>  
                <el-table-column  fixed="right" label="操作"  width="80">
                    <template slot-scope="scope">
                        <el-button @click="handleNewArrange(scope.row)" v-if="scope.row.status === '未编排'"
                        type="text" style="font-size:16px;color:red">确认加桌</el-button>
                    </template>
                </el-table-column>
            </el-table>       
        </div>  
    </div>   
   </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'

export default {
    props:{
        pubId: {
            type: String,
            default: ''
        },
        pubType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 编排数据data
            dataList: [],
            firstTableData: [],
            secondTableData: [],
            // 人工调整数据data
            tableData: [],
            tableDataSetFirst: [],
            tableDataSetSecond: [],           
            isShow: false,
            isReady: false,
            round: '',
            disabled: false,
            playerNo1: '',
            playerNo2: '',
            roundOne: true,
            isShowEdit: false,
            errorMsg: '',
            randomStatus: false,
            clickCount: 0,
            loading: false,
        }
    },
    created() {

    },
    mounted() {
    },
    computed:{
        // ...mapState(['round'])
    },
    methods: {
        ...mapMutations(['SET_ROUND']),
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return 'green-row'
            }
        },
        closeShow(){
            this.isShow = false
            this.isShowEdit = false
        },
        // 赛事编排对阵查询
        initData(){
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    this.disabled = false
                    let result = res.Data.DataTable                    
                    if(result.length > 0){                      
                        let arr  = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                status: item['状态'],
                                matchStatus: item['参赛状态'],
                            }
                        })   
                        if(this.pubType === '2'){
                            if(arr.length % 2 ===0){
                                this.dataList = this.selectDeskNo(arr)   
                                let  playerArr  = JSON.parse(JSON.stringify(this.dataList))
                                if(playerArr.length > 10){
                                    const splitSize = Math.round(playerArr.length / 2); 
                                    this.firstTableData = playerArr.slice(0, splitSize);  
                                    this.secondTableData = playerArr.slice(splitSize);  
                                }else{
                                    this.firstTableData = playerArr
                                    this.secondTableData = []
                                }
                            }else{
                                let num = arr.length % 2
                                this.$message({
                                    type:'error',
                                    message: `选手还差${num}对,不能编排,请先添加选手！`,
                                    duration: 5000, 
                                })
                            }
                        }else{
                            if(arr.length % 4 ===0){
                                this.dataList = this.selectDeskNo(arr)   
                                let  playerArr  = JSON.parse(JSON.stringify(this.dataList))
                                if(playerArr.length > 10){
                                    const splitSize = Math.round(playerArr.length / 2); 
                                    this.firstTableData = playerArr.slice(0, splitSize);  
                                    this.secondTableData = playerArr.slice(splitSize);  
                                }else{
                                    this.firstTableData = playerArr
                                    this.secondTableData = []
                                }
                            }else{
                                let num = arr.length % 4 
                                // console.log(num)
                                this.$message({
                                    type:'error',
                                    message: `选手还差${num}人,不能编排,请先添加选手！`,
                                    duration: 5000, 
                                })
                            }
                        }  
                        // console.log('编排2',this.dataList)
                        let statusErr = this.dataList.filter(i=>i.status === '未编排')
                        let statusErr2 = this.dataList.filter(i=>i.status === '已编排')
                        // console.log('编排数据', statusErr,statusErr2)
                        
                        if(statusErr2.length > 0 && !this.isShowEdit){
                            this.isReady = true                            
                        }else{
                            this.isReady = false
                        }
                        if(statusErr.length >0){
                            this.errorMsg = '有选手未编排，请先点击编排按钮！'                           
                        }else{
                            this.errorMsg = ''
                        }
                        if(statusErr.length >0 && statusErr2.length > 0){
                            this.errorMsg = '有新加选手，请确认加桌!'
                            this.roundOne = false
                        }
                        this.tableData = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                round: item['第几轮'],
                                status: item['状态'],
                                matchStatus: item['参赛状态'],
                            }
                        }) 
                        let  tableArr  = JSON.parse(JSON.stringify(this.tableData))
                        if(tableArr.length > 10){
                            const splitSize = Math.round(tableArr.length / 2); 
                            this.tableDataSetFirst = tableArr.slice(0, splitSize);  
                            this.tableDataSetSecond = tableArr.slice(splitSize);  
                        }else{
                            this.tableDataSetFirst = tableArr
                            this.tableDataSetSecond = []
                        }                                                                 
                    }else{
                        this.tableData = []
                        this.dataList = []
                        this.tableDataSetFirst = []
                        this.tableDataSetSecond = []
                        this.firstTableData = []
                        this.secondTableData = []
                        this.errorMsg = ''
                        this.isReady = false                          
                    }    
                    this.loading = false                
                }else{
                    if(res.ErrorCode === 30479){
                        this.errorMsg = '请先清除编排后在重新编排！'
                    }else{
                        this.errorMsg = ''
                    }
                    this.tableData = []
                    this.dataList = []
                    this.loading = false
                    this.$message(
                        {
                            type: 'error',
                            message: res.Message,
                            duration: 5000
                        }
                    )
                }
            })
        },
        // 查询轮数
        getNewRound(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数']
                        }
                    })
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.SET_ROUND(this.round)
                    if(this.round){
                        this.initData()  
                    }
                }
            })
        },   
        // 清除编排
        handleClearArrange(){
            this.isShowEdit = false
            this.$confirm('确定清除本轮编排吗？').then(res=>{
                let params = {
                    opcode: this.$code.ScoreDeleteRound,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                    i_games_id: 0,
                    i_desk_no: 0,
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        this.errorMsg = ''
                        this.isReady = false   
                        this.roundOne = true                                    
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }).catch(err=>{

            })
        }, 
        // 编排 循环调用接口
        handleArrange(){
            this.isShow = false    
            this.isReady = true   
            this.disabled = true     
            this.isShowEdit = false 
            this.loading= true
            this.callApisArrange(this.tableData).then(()=>{
                this.initData()
                console.log("调用完了")
            })
        },       
        // 编排异步调用函数 
        async callApisArrange(arr) {  
            return arr.reduce(async (promiseChain, data) =>{
                await  promiseChain
                try {                      
                    const res = await this.submitArrange(data); 
                    // console.log(data)  
                } catch (error) {  
                    // console.error(`Error calling API at`, error);  
                }  
            }, Promise.resolve()) 
        },  
        // 调用编排接口
        submitArrange(row){
            return new Promise((resolve, reject) => {    
                let params = {
                    opcode: this.$code.PubArrangeSet,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                    i_desk_no: row.deskNo,
                    v_seat: row.seat,
                    i_players_number: row.id,
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {                        
                        resolve(res)                 
                    }
                }).catch(err=>reject(err)) 
            })         
        },
        // 一键编排
        handleArrangeAll(){
            this.isShow = false    
            this.isReady = true   
            this.disabled = true     
            this.isShowEdit = false 
            this.loading= true
            let params = {
                opcode: this.$code.PubArrangeSetAll,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {                        
                    this.loading= false  
                    this.initData()         
                }
            }).catch(err=>{}) 
        },    
        selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameWE = ''
                        let usernameSN = ''
                        let usernameW= ''
                        let usernameE= ''
                        let usernameS= ''
                        let usernameN= ''
                        if(this.pubType === '1'){
                            usernameW = (newArr.filter(i =>  i.seat.includes('东')))[0].username
                            usernameE = (newArr.filter(i =>  i.seat.includes('西')))[0].username
                            usernameS = (newArr.filter(i =>  i.seat.includes('南')))[0].username
                            usernameN = (newArr.filter(i =>  i.seat.includes('北')))[0].username                                                      
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username                          
                        }  
                        if(this.pubType === '1'){
                            result.push({
                                deskNo: item.deskNo,
                                usernameW: usernameW,
                                usernameE: usernameE,  
                                usernameS: usernameS,
                                usernameN: usernameN,
                                playerNo:  item.id,
                                status: item.status,
                                statusW: (newArr.filter(i =>  i.seat.includes('东')))[0].matchStatus,
                                statusE: (newArr.filter(i =>  i.seat.includes('西')))[0].matchStatus,
                                statusS: (newArr.filter(i =>  i.seat.includes('南')))[0].matchStatus,
                                statusN: (newArr.filter(i =>  i.seat.includes('北')))[0].matchStatus,           
                            })
                        }else{
                            result.push({
                                deskNo: item.deskNo,
                                usernameWE: usernameWE,
                                usernameSN: usernameSN, 
                                playerNo:  item.id,
                                status: item.status,
                                statusWE: (newArr.filter(i =>  i.seat.includes('东')))[0].matchStatus,
                                statusSN: (newArr.filter(i =>  i.seat.includes('北')))[0].matchStatus,                         
                            })
                        }                     
                       
                 }
             });
             return result
         }, 
        // selectDeskNo(arr){
        //     let result = []
        //     arr.forEach(item => {
        //         if(!result.some(i => i.deskNo === item.deskNo)){
        //             result.push({
        //                 deskNo: item.deskNo,
        //                 users: arr.filter(user => user.deskNo === item.deskNo)
        //             })
        //         }
        //     });
        //     return result
        // },
        editTable(){
            this.isShow = true
            this.isReady = false
            this.isShowEdit = !this.isShowEdit
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    this.tableData = result.map(item=>{
                    let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                        return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: username,
                            phone: item['选手手机号'],
                            company: item['协会（俱乐部）'],
                            userId: item['选手账号'],
                            seat: item['座位'],
                            round: item['第几轮'],
                         }
                     })
                    //  this.tableData = arr && arr.map((item,index)=>{
                    //     let directions = ['东','西','南','北']
                    //     const directionIndex = index % directions.length;                        
                    //     return { ...item, seat:  directions[directionIndex]}
                    // })
                 }
             })
        },
        updateDesk(row){
            let params = {
                opcode: this.$code.PubArrangeSet,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_desk_no: row.deskNo,
                v_seat: row.seat,
                i_players_number: row.id,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                //    console.log(res)                  
                }
            })
        },
        savePlayer(){
            if(this.playerNo1 === '' ||  this.playerNo2 === ''){
                this.$message.error("请输入选手编号~")
                return false
            }
            if(this.playerNo1 === this.playerNo2){
                this.$message.error("请输入不同的选手编号~")
                return false
            }
            let params = {
                opcode: this.$code.playerNoExchange,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_players_number: this.playerNo1,
                new_players_number: this.playerNo2
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {  
                   this.playerNo1 = ''
                   this.playerNo2 = ''
                   this.initData()           
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 顺序编号 
        handleSetId(value){
            let params = {
                opcode: this.$code.SetPlayerId,
                i_serial_mark: this.pubId,
                i_flag: 1
            }
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    
                } 
            })
        },
        // 随机编排
        handleArrangeRandom(){
            this.handleSetId()            
            this.$confirm('确定本轮赛事随机编排吗？').then(res=>{
                this.loading = true
                let params = {
                    opcode: this.$code.ArrangeRandom,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                    this.isReady = true                 
                    this.initData()       
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }).catch(err=>{

            })           
        },
        toggleFullScreen(){
            // this.$router.push({
            //     path: '/fullArrange',
            //     query:{
            //         id: this.pubId,
            //         type: this.pubType
            //     }
            // })
            const routeUrl = this.$router.resolve({ name: 'fullArrange', query: { id: this.pubId,type: this.pubType} });
            window.open(routeUrl.href, '_blank');   
            
        },  
        cancel(){
            this.isShow = false
        },        
        backNext(){
            this.isShow = false
            this.isReady = true  
            this.isShowEdit = !this.isShowEdit  
            this.playerNo1 = ''
            this.playerNo2 = ''
            this.initData()
        },
        // 只能输入数字，限制输入其它字符
        handleInput1(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.playerNo1 = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
                const num = value.match(/\d+/g)
                this.playerNo1 = num ? num.join('') : ''
            }
        },
        // 只能输入数字，限制输入其它字符
        handleInput2(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.playerNo2 = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
                const num = value.match(/\d+/g)
                this.playerNo2 = num ? num.join('') : ''
            }
        },
        changeSeat(row, column, cell, event){
            this.clickCount++ 
            let id = row.id            
            if(this.clickCount % 2){
                this.playerNo1 = id
            }else{
                this.playerNo2 = id
            }            
        },
        async callApisSequentially(arr) { 
            return arr.reduce(async (promiseChain, data) =>{
                await  promiseChain
                try {  
                    const res = await this.test(data); 
                    // console.log(data)  

                } catch (error) {  
                    console.error(`Error calling API at`, error);  
                }  
            }, Promise.resolve()) 
        },
        test(row){
            return new Promise((resolve, reject) => {                
                let params = {
                    opcode: this.$code.PubArrangeSet,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                    i_desk_no: row.deskNo,
                    v_seat: row.seat,
                    i_players_number: row.id,
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        resolve(res)             
                    }
                }).catch(err=> reject(err))
            })
        },
        // 某一桌未编排
        handleNewArrange(row){
            // console.log('第几桌',row.deskNo)
            let deskNo = row.deskNo
            let arr = this.tableData
            // let newArr1 = arr.filter(i=>i.status === '未编排')
            let newArr = arr.filter(i=>i.deskNo === deskNo)
            this.callApisSequentially(newArr).then(()=>{
                this.initData()
            })
        }
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.title{
    font-size: 28px;
    margin-bottom: 10px;
}
.desk-table{
    width: 550px
}
.custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .el-input{
    font-size: 20px;
}
table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid #999;
    padding: 8px;
    text-align: left;
    font-size: 20px;
  }
  tr:nth-child(even) {
    background-color: #bbffbb;
  }
  thead th {
    background-color: #f2f2f2;
    font-size: 18px;
    text-align: center;
  }
  .table-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
  }
  .el-table >>> .green-row{
    background-color: #bbffbb;
    font-size: 20px;
  }
    .el-table >>> .gray-row{
    background-color: #b9b5b5;
    }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
    font-size: 20px;
  }
.mg-l-20{
    margin-left: 20px;
}
.edit-btn{
    position: absolute;
    right:0
}
.edit-item{
    margin-right: 90px;
}
.tips{
    color: red;
    font-weight: bold;
    margin-right: 10px;
}
.player-input{
    width: 110px;
}
.player-input >>> .el-input__inner{
    font-size: 20px
}
.save-btn{
    margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/components/arrange.vue